import React from 'react';
import { ageLabel } from '../utils/modelAge';

/**
 * " · 3 days ago" after "Model v4" — how long the live model has been live
 * (Apal 2026-11-02: "with version # days ago, months ago, years ago" … "dont
 * change colors … just giving simple info … to minimize space" … "dont make
 * things too complicated" — the version history can come later).
 *
 * - Plain words in the line's own colour.
 * - since = the start of the version's CURRENT run (MV's numbers repeat).
 * - The first model covers all history before the first change: "original
 *   model", never a release "30 years ago".
 * - Carries its own " · ", so a line never shows a dangling dot without it.
 */
const fmtDate = (iso) => `${iso.slice(8, 10)}-${iso.slice(5, 7)}-${iso.slice(0, 4)}`;   // DD-MM-YYYY

export function ModelAge({ since, original = false, testId, today }) {
  if (original) return <>{' · '}<span data-testid={testId}>original model</span></>;
  if (!since) return null;
  return <>{' · '}<span data-testid={testId} title={`Live since ${fmtDate(since)}`}>{ageLabel(since, today || new Date())}</span></>;
}
